import { getDiscoveryTargetForPath } from '@revelio/core/global-ai-assistant/discovery-targets';

import { isAnalyticsEntity } from '../CustomDash/utils/revelio-primary-filter-entity-switch';
import type { GlobalAssistantEntityType } from './global-ai-assistant-api';

/**
 * Compare dashboard navigate paths from global assistant page matches with the
 * current router location pathname (no query string).
 */
function normalizeGlobalAssistantTargetPath(path: string): string {
  const trimmed = path.trim().replace(/\/+$/, '');
  const normalized = trimmed.length === 0 ? '/' : trimmed;
  const parts = normalized.split('/').filter(Boolean);
  const [entity, page] = parts;
  const isDashboardEntity = isAnalyticsEntity(entity);

  if (!isDashboardEntity || page === undefined) {
    return normalized;
  }
  if (page === 'screener') {
    return `/${entity}/screener`;
  }
  return `/${entity}/${page}`;
}

export function globalAssistantPathsMatch(
  pathname: string,
  targetPath: string
): boolean {
  return (
    normalizeGlobalAssistantTargetPath(pathname) ===
    normalizeGlobalAssistantTargetPath(targetPath)
  );
}

export function inferEntityTypeFromNavigatePath(
  navigatePath: string,
  fallback: GlobalAssistantEntityType
): GlobalAssistantEntityType {
  const discovery = getDiscoveryTargetForPath(navigatePath);
  if (discovery) return discovery.entityType;
  const seg = navigatePath.split('/').filter(Boolean)[0];
  if (isAnalyticsEntity(seg)) {
    return seg;
  }
  return fallback;
}
